import { serviceUrlsContext } from './serviceUrlsContext';
import { useServiceUrlsProvider } from './useServiceUrlsProvider';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Simple Context for keeping and providing service URLs to components down the tree.
 */
export const ServiceUrlsProvider = ({
  serviceUrls,
  children
}) => {
  const contextValue = useServiceUrlsProvider({
    serviceUrls
  });
  return /*#__PURE__*/_jsx(serviceUrlsContext.Provider, {
    value: contextValue,
    children: children
  });
};
//# sourceMappingURL=ServiceUrlsProvider.js.map